export default {
    PENDING_PROPOSAL_CHANGE: { id: 1, collection: "pendingProposalChange"},
    ACCEPTED_PROPOSAL_CHANGE: { id: 2, collection: "acceptedProposalChange"},
    REJECTED_PROPOSAL_CHANGE: { id: 3, collection: "rejectedProposalChange"},
    NEW_CHANGE: { id: 4, collection: "newChange"},
    CHANGE_REQUEST_FINALIZE: { id: 5, collection: "changeRequestFinalize"},
    CHANGE_REJECTED: { id: 6, collection: "changeRejected"},
    CHANGE_FINALIZED: { id: 7, collection: "changeFinalized"}
}
